import React, { useState, useEffect } from "react";
import Footer from "./Essentials/Footer";
import Navbar from "./Essentials/Navbar";
import "./Css/Research.css";
import { useLocation } from "react-router-dom";

function Research() {
  const [papers, setPapers] = useState([]);
  const { pathname } = useLocation();

  useEffect(() => {
    fetch("https://rohitpidishetty.github.io/NFRAC_Projects/research_papers.json")
      .then(res => res.json())
      .then(data => setPapers(data));
  }, []);

  const isNfrac = pathname.replace("/", "") === "nfrac_research_papers" && window.innerWidth > 750;

  return (
    <div className={`page-wrapper ${isNfrac ? "nfrac-theme" : ""}`}>
      <Navbar />

      <main className="research-container">
        <div className="papers-list">
          {papers && papers.map((paper, index) => (
            <div className="paper-card" key={index}>
              <div className="paper-status">
                <span className="status-badge">{paper.published}</span>
                <span className="paper-year">{paper.year}</span>
              </div>

              <div className="paper-info">
                <h2>{paper.name}</h2>
                <p className="publisher-name">{paper.publisher}</p>
              </div>

              <div className="paper-action">
                <a href={paper.link} target="_blank" rel="noreferrer" className="apple-link">
                  View Dissertation
                  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3.5 2H10M10 2V8.5M10 2L2 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </a>
              </div>
            </div>
          ))}
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default Research;